import { Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

// Pages
import HomePage from "./pages/HomePage";
import AdminLoginPage from "./pages/admin/LoginPage";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/DashboardPage";
import AdminApplications from "./pages/admin/ApplicationsPage";
import AdminApplicationDetail from "./pages/admin/ApplicationDetailPage";
import AdminContacts from "./pages/admin/ContactsPage";
import AdminVacancies from "./pages/admin/VacanciesPage";
import AdminVacancyForm from "./pages/admin/VacancyFormPage";
import AdminVacancyDetail from "./pages/admin/VacancyDetailPage";

export default function App() {
  return (
    <>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<HomePage />} />

        {/* Admin routes */}
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="vacancies" element={<AdminVacancies />} />
          <Route path="vacancies/:id" element={<AdminVacancyDetail />} />
          <Route path="vacancies/new" element={<AdminVacancyForm />} />
          <Route path="vacancies/:id/edit" element={<AdminVacancyForm />} />
          <Route path="applications" element={<AdminApplications />} />
          <Route path="applications/:id" element={<AdminApplicationDetail />} />
          <Route path="contacts" element={<AdminContacts />} />
        </Route>
      </Routes>
      <Toaster position="top-right" richColors />
    </>
  );
}
